import { useEffect, useRef } from "react";

export default function HighlightedText({ text }) {
    const markRef = useRef(null);

    useEffect(() => {
        const element = markRef.current;

        if (element) {
            // Add the animation class after the component mounts
            // delay the animation for 200ms to allow the component to render
            setTimeout(() => {
                element.classList.add("highlight-me");
            }, 200);
        }
    }, []);

    return (
        <>
            <style>
                {`
                    .highlight-container .background {
                        transition: width 1s ease-in-out; /* Smooth animation */
                    }

                    .highlight-container .text {
                        z-index: 2; /* Keep text above the background */
                    }

                    .highlight-me .background {
                        width: 100%; /* Expand the background */
                    }
                `}
            </style>
            <span className="highlight-container relative inline-block px-[5px]" ref={markRef}>
                <span className="background bg-cv top-0 absolute left-0 h-full w-0 rounded-[5px] p-[5px]"></span>
                <span className="text relative">{text}</span>
            </span>
        </>
    );
}
